export const LOCATIONS = [
  { label: "New York, NY", value: "new-york-ny" },
  { label: "Los Angeles, CA", value: "los-angeles-ca" },
  { label: "Chicago, IL", value: "chicago-il" },
  { label: "Houston, TX", value: "houston-tx" },
  { label: "Phoenix, AZ", value: "phoenix-az" },
  { label: "Philadelphia, PA", value: "philadelphia-pa" },
  { label: "San Antonio, TX", value: "san-antonio-tx" },
  { label: "San Diego, CA", value: "san-diego-ca" },
  { label: "Dallas, TX", value: "dallas-tx" },
  { label: "San Jose, CA", value: "san-jose-ca" },
  { label: "Austin, TX", value: "austin-tx" },
];

export const SENIORITIES = [
  { label: "Intern", value: "intern" },
  { label: "Entry Level", value: "entry-level" },
  { label: "Junior", value: "junior" },
  { label: "Mid Level", value: "mid-level" },
  { label: "Senior", value: "senior" },
  { label: "Lead", value: "lead" },
  { label: "Manager", value: "manager" },
  { label: "Director", value: "director" },
  { label: "VP", value: "vp" },
];

export const IMG_CATIGORIES = [
  { label: "Supply Chain", value: "supply-chain" },
  { label: "Brand Specific", value: "brand-specific" },
  { label: "Corporate", value: "corporate" },
  { label: "Brand Homes", value: "brand-home" },
];

export const WORKSETUPS = [
  { label: "Hybrid", value: "hibrid" },
  { label: "On-Site", value: "on-site" },
  { label: "Remote", value: "remote" },
];

export const SLOGANS = [
  { label: "Build a legacy", value: "build-a-legacy" },
  { label: "Family owned", value: "family-owned" },
  { label: "Unleash your potential", value: "unleash-your-potential" },
];
